module.exports = __webpack_public_path__ + "img/maldives.6edf3fa8.svg";